import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getClaim = claimId =>
  call(websocketFetch, 'get_claim', { claim_id: claimId });
